var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wizard-step-2" },
    [
      _c("document-summary", {
        attrs: {
          type: _vm.selectedDocumentInfo,
          icon: _vm.icon,
          description: _vm.description
        }
      }),
      _c("location-breadcrumb", { attrs: { location: _vm.location } }),
      _c(
        "b-alert",
        { staticClass: "info-alert", attrs: { show: "", variant: "info" } },
        [
          _c("feather-icon", {
            staticClass: "mr-2",
            attrs: { icon: "InfoIcon", size: "18" }
          }),
          _vm._v(
            " El documento se creará en la ubicación actual del repositorio. "
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }